var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIconforPfizerPending3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 90,
    viewBox: "0 0 95 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 41.3C51.0751 41.3 56 35.6364 56 28.65C56 21.6636 51.0751 16 45 16C38.9249 16 34 21.6636 34 28.65C34 35.6364 38.9249 41.3 45 41.3Z",
    fill: "#734BD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7816 45.0987L53.7941 41.4688C53.1848 41.1916 52.4884 41.2659 51.9384 41.6637L50.1883 42.9352C47.1344 45.155 43.1397 45.1208 40.1191 42.8509L38.5616 41.6797C38.0172 41.2719 37.3208 41.1856 36.7078 41.4547L28.298 45.1248C26.1664 46.0549 24.6052 48.0778 24.1348 50.5185L23.0644 56.0808C22.6755 58.1017 24.0978 60 26.0016 60H63.9984C65.9022 60 67.3245 58.1017 66.9356 56.0808L65.8522 50.4522C65.3911 48.0496 63.8669 46.0489 61.7816 45.0987Z",
    fill: "#734BD1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.5,
    stroke: "#734BD1",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 16,
    r: 14.5,
    fill: "#FF9E2D",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4609 72.8516H42.5312V71.1641H45.4609C45.9401 71.1641 46.3281 71.0859 46.625 70.9297C46.9271 70.7682 47.1484 70.5495 47.2891 70.2734C47.4297 69.9922 47.5 69.6719 47.5 69.3125C47.5 68.9635 47.4297 68.638 47.2891 68.3359C47.1484 68.0339 46.9271 67.7891 46.625 67.6016C46.3281 67.4141 45.9401 67.3203 45.4609 67.3203H43.2344V77H41.0859V65.625H45.4609C46.3464 65.625 47.1016 65.7839 47.7266 66.1016C48.3568 66.4141 48.8359 66.849 49.1641 67.4062C49.4974 67.9583 49.6641 68.5885 49.6641 69.2969C49.6641 70.0312 49.4974 70.6641 49.1641 71.1953C48.8359 71.7266 48.3568 72.1354 47.7266 72.4219C47.1016 72.7083 46.3464 72.8516 45.4609 72.8516Z",
    fill: "#734BD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIconforPfizerPending3);
export default __webpack_public_path__ + "static/media/Staff Icon for Pfizer - Pending_3.0e29740ab13ce464215224d62790427c.svg";
export { ForwardRef as ReactComponent };